var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar border d-flex align-items-center",staticStyle:{"padding":"10px"}},[_c('b-row',[_c('b-col',[_c('birthday-cake',{staticStyle:{"margin-left":"75px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }